import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter, map, Observable, startWith, take } from 'rxjs';
import { MaintenanceStateService, MobileAndNotSupportBrowserService } from './services';

@Component({
  selector: 'app-shell',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {

  get isSupported(): boolean {
    return this.mobileAndNotSupportBrowserService.isCurrentBrowserSupported;
  }

  protected isLoading$: Observable<boolean>;
  protected isMaintenance$: Observable<boolean>;

  constructor(
    private mobileAndNotSupportBrowserService: MobileAndNotSupportBrowserService,
    private router: Router,
    private maintenanceState: MaintenanceStateService
  ) {}

  ngOnInit(): void {
    this.isMaintenance$ = this.maintenanceState.isMaintenance();
    this.mobileAndNotSupportBrowserService.initialize();
    this.isLoading$ = this.router.events.pipe(
      filter(
        (event) =>
          event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel
      ),
      map(() => false),
      take(1),
      startWith(true)
    );
  }
}
